import {HttpClient} from '@angular/common/http';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {LocalizationService} from '@npck/libs/commons';
import {DOCUMENT_TYPE} from '../../domain/query-param.keys';

@Component({
    templateUrl: 'document.component.html',
    standalone: false
})
export class DocumentComponent implements OnInit {
    documentType: DocumentType;
    html: string;

    constructor(
        private httpClient: HttpClient,
        private activatedRoute: ActivatedRoute,
        private localizationService: LocalizationService,
    ) {
        this.documentType = this.activatedRoute.snapshot.queryParams[DOCUMENT_TYPE];
    }

    ngOnInit(): void {
        const locale = this.localizationService.currentLanguage.locale;
        let htmlPath;
        if (this.documentType == DocumentType.PRIVACY_POLICY) {
            htmlPath = `assets/documents/privacy-policy-${locale}.html`;
        } else {
            htmlPath = `assets/documents/user-agreement-${locale}.html`;
        }
        this.httpClient.get(htmlPath, {responseType: 'text'}).subscribe((response) => this.html = response);
    }

    back(): void {
        history.back();
    }
}

export enum DocumentType {
    USER_AGREEMENT = 'USER_AGREEMENT',
    PRIVACY_POLICY = 'PRIVACY_POLICY'
}
